import React from 'react';
import { useTranslation } from 'react-i18next';
import { voiceCallsEntityTransformer } from '../../../utils/transformers';
import DataGrid from '../../DataGrid/DataGrid';
import { PaginationMode } from '../../DataGrid/types';
import {
    generateColumns,
    useStyles,
    VoiceCallsTableRowInterface,
} from './VoiceCalls.utils';
import { TransactionTableInterface } from '../utils';
import classNames from 'classnames';

const VoiceCalls: React.VFC<TransactionTableInterface> = ({
    currency,
    data,
    onPageChange,
    onPageSizeChange,
    initialPageSize,
    loading,
    rowCount,
    userDateTimeFormat,
    className,
}) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const columns = generateColumns(t, currency, userDateTimeFormat);

    const items: VoiceCallsTableRowInterface[] = data.map(
        voiceCallsEntityTransformer,
    );

    return (
        <DataGrid<VoiceCallsTableRowInterface>
            data={items}
            dataQa={'voice-calls-table'}
            loading={loading}
            columns={columns}
            rowCount={rowCount}
            paginationMode={PaginationMode.Server}
            onPageChange={onPageChange}
            onPageSizeChange={onPageSizeChange}
            initialPageSize={initialPageSize}
            classes={{
                header: classes.header,
                tableContainer: classNames(classes.tableContent, className),
            }}
        />
    );
};

export default VoiceCalls;
